module.exports = __webpack_public_path__ + "img/weddings_04_V.cf5256a4.webp";